<template>
<v-card>
    <v-card-title class="headline">{{ title }}</v-card-title>
    <v-card-text>
        <v-form ref="editForm" v-model="formValid">
            <v-layout class="dialog-content">
                <v-flex xs12>
                    <v-layout wrap>
                        <v-flex v-if="!isUserDefinedValue(editData.AttributeValueID)" xs12>
                            <v-autocomplete label="Value" :items="attributeValues" item-value="AttributeValueID" item-text="Name" v-model="editData.AttributeValueID" :rules="[rules.requiredObject]" box clearable placeholder="Select Value">
                            </v-autocomplete>
                        </v-flex>
                        <v-flex v-if="isUserDefinedValue(editData.AttributeValueID)" xs12>
                            <v-text-field v-if="!isDateType(editData.AttributeValueID)" box clearable label="Value" v-model="editData.UserDefinedValue" 
                                :rules="getUserDefinedValueRules(editData.AttributeValueID)" 
                                type="number"
                                :readOnly="isDateType(editData.AttributeValueID)"
                                @click="optionalTextFieldClick(editData.AttributeValueID)"
                                counter>
                            </v-text-field>
                            <v-menu v-else v-model="dateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="editData.UserDefinedValue"  
                                    label="Date" 
                                    prepend-icon="event" 
                                    readonly v-on="on" 
                                    append-icon="close" 
                                    :rules="getUserDefinedValueRules(editData.AttributeValueID)" 
                                    @click:append="editData.UserDefinedValue = null">
                                    </v-text-field>
                                </template>
                                <v-date-picker :value="formatMomentDate(editData.UserDefinedValue)" @input="updateUserDefinedDate"></v-date-picker>
                            </v-menu>
                        </v-flex>                        
                        <v-flex xs12>
                            <v-menu v-model="startDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field :value="formatDate(editData.StartDate)" label="Date From" prepend-icon="event" readonly v-on="on" append-icon="close" :rules="[rules.required,beforeEndDate]" @click:append="clearStartDate"></v-text-field>
                                </template>
                                <v-date-picker :value="formatDateYMD(editData.StartDate)" :min="editData.PlantingDate" :max="editData.CropEndDate" @input="updateStartDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12>
                            <v-menu v-model="endDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field :value="formatDate(editData.EndDate)" label="Date To" prepend-icon="event" readonly v-on="on" append-icon="close" :rules="[rules.required,afterStartDate]" @click:append="clearEndDate"></v-text-field>
                                </template>
                                <v-date-picker :value="formatDateYMD(editData.EndDate)" :min="editData.PlantingDate" :max="editData.CropEndDate" @input="updateEndDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
        <v-alert :value="submitError != null" outline type="error">
            <span>{{ submitError }}</span>
        </v-alert>
    </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :disabled="!formValid || !attribute" @click="submit">OK</v-btn>
        <v-btn color="error" @click="cancel">Cancel</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import validationRules from "@/helpers/validationrules";
import UtilService from '@/services/utilService.js';
import moment from 'moment';

export default {
    props: {
        item: {
            required: true,
            type: Object
        },
        productTypeID :{
            required: true,
            type: Number
        },
        submitError: {
            required: false,
            type: String
        },
    },
    data() {
        return {
            startDateMenu: false,
            endDateMenu: false,
            rules: validationRules.rules,
            editData: {},
            formValid: false,
            dateMenu: false,        
        }
    },
    computed: {
        attributeValues() {
            return this.$store.getters["CropStore/getAttributeValues"](this.item.AttributeID)
        },
        attribute() {
            return this.$store.getters["CropStore/getAttributes"](this.productTypeID).find(a => a.AttributeID === this.item.AttributeID)
        },
        title() {
            if (this.attribute) {
                return this.attribute.Name
            } else {
                return "Attribute not available!";
            }
        }
    },
    methods: {
        isUserDefinedValue(attributeValueID) {            
            return attributeValueID > 0 && this.attributeValues.find(a => a.AttributeValueID === attributeValueID).UserDefinedValue;
        },
        getUserDefinedValueRules(attributeValueID) {
            let rules = [];

            let attribute = this.attributeValues.find(a => a.AttributeValueID === attributeValueID);

            if (attribute && attribute.UserDefinedType) {
                rules.push(this[attribute.UserDefinedType]);
            }
            return rules;
        },
        integer(v){
            if(v == null || !v.toString().match(/^[0-9]{1,15}$/)){
                return "Please enter a whole positive number";
            }

            return false;
        },
        decimal(v){
            if(v == null || !v.toString().match(/^[0-9]{1,15}.?[0-9]{0,3}$/)){
                return "Please enter a number in the format of XXXXX.XXX";
            }

            return false;
        },
        date(v){
            if(v == null){
                return "Please select a date";
            }
            return false;
        },
        clearStartDate() {
            this.startDateMenu = true;
            this.$set(this.editData, 'StartDate', null);
            this.startDateMenu = false;
        },
        updateStartDate(v) {
            this.$set(this.editData, 'StartDate', v);
            this.startDateMenu = false;
            if(this.$refs && this.$refs.editForm) {
                this.$refs.editForm.validate();
            }
        },
        updateUserDefinedDate(v) {
            console.log(v);
            this.$set(this.editData, 'UserDefinedValue', this.formatDateDMY(v));
            this.dateMenu = false;
        },
        beforeEndDate(v){
            if(moment(this.editData.EndDate) < moment(v,"DD/MM/YYYY")){

                return "Must be before end date";
            }

            return false;
        },
        afterStartDate(v){
            if((moment(v,"DD/MM/YYYY") < moment(this.editData.StartDate))){
                return "Must be after start date";
            }

            return false;
        },
        clearEndDate() {
            this.endDateMenu = true;
            this.$set(this.editData, 'EndDate', null);
            this.endDateMenu = false;
        },
        updateEndDate(v) {
            this.$set(this.editData, 'EndDate', v);
            this.endDateMenu = false;
            if(this.$refs && this.$refs.editForm) {
                this.$refs.editForm.validate();
            }
        },
        formatDateYMD(v) {
            if(v) {
                return UtilService.formatDateYMD(v);
            } 
            return null;
        },
        formatDate(v) {
            if (v) {
                return UtilService.formatDateDMY(v, '/');
            }

            return null;
        },
        formatMomentDate(v) {
            if(v) {
                return moment(v, "DD/MM/YYYY").format("YYYY-MM-DD");
            }
            return null;
        },
        formatDateDMY(v) {
            if (v) {
                return UtilService.formatDateDMY(v, '/');
            }

            return null;
        },
        cancel() {
            this.$emit("cancel");
        },
        submit() {
            this.$emit("submit", this.editData);
        },
        optionalTextFieldClick(attributeValueID) {
            if(this.isDateType(attributeValueID)) {
                return this.dateMenu = true;
            }
        },
        isDateType(attributeValueID) {
            let attribute = this.attributeValues.find(a => a.AttributeValueID === attributeValueID);
            return attribute && attribute.UserDefinedType.toLowerCase() == 'date';
        }
    },
    async created() {

        this.editData = JSON.parse(JSON.stringify(this.item));

        // Default selection of user defined attributes
        if (this.attributeValues.length == 1 && this.attributeValues[0].UserDefinedValue) {
            this.editData.AttributeValueID = this.attributeValues[0].AttributeValueID;
        }
    }
}
</script>
